"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function updateTooltipContainerPosition(tooltipContainerRef) {
  var tooltipContainer = tooltipContainerRef.current;
  var boundingClientRect = tooltipContainer === null || tooltipContainer === void 0 ? void 0 : tooltipContainer.getBoundingClientRect();
  var viewportPositionX = "".concat(boundingClientRect === null || boundingClientRect === void 0 ? void 0 : boundingClientRect.x, "px");
  tooltipContainer === null || tooltipContainer === void 0 ? void 0 : tooltipContainer.style.setProperty('--tooltip-container-position-x', viewportPositionX);
}

var Tooltip = function Tooltip(_ref) {
  var _classNames;

  var trigger = _ref.trigger,
      qaClasses = _ref.qaClasses,
      customClasses = _ref.customClasses,
      tooltipMessage = _ref.tooltipMessage,
      withArrow = _ref.withArrow,
      position = _ref.position,
      verticalPosition = _ref.verticalPosition,
      noWrap = _ref.noWrap,
      top = _ref.top,
      left = _ref.left,
      onTooltipClick = _ref.onTooltipClick,
      renderAsButton = _ref.renderAsButton;
  var tooltipContainerRef = (0, _preact.createRef)();
  var Tag = renderAsButton ? 'button' : 'div';
  return (0, _preact.h)(Tag, {
    className: "tooltip-container",
    ref: function ref(el) {
      return tooltipContainerRef.current = el;
    },
    onMouseOver: function onMouseOver() {
      return updateTooltipContainerPosition(tooltipContainerRef);
    },
    onClick: onTooltipClick,
    role: renderAsButton ? 'button' : undefined
  }, (0, _preact.h)("span", {
    className: (0, _classnames.default)('tooltip-trigger', qaClasses)
  }, trigger), tooltipMessage && (0, _preact.h)("div", {
    className: (0, _classnames.default)(customClasses, 'tooltip-message', (_classNames = {
      'tooltip-message--no-wrap': noWrap
    }, (0, _defineProperty2.default)(_classNames, "tooltip-message--".concat(position), position), (0, _defineProperty2.default)(_classNames, "tooltip-message--".concat(verticalPosition), verticalPosition), _classNames)),
    style: _objectSpread(_objectSpread({}, top !== undefined && top !== null && {
      top: "".concat(top, "px")
    }), left !== undefined && left !== null && {
      left: "".concat(left, "px")
    })
  }, withArrow && (0, _preact.h)("i", {
    className: "arrow"
  }), tooltipMessage));
};

var _default = Tooltip;
exports.default = _default;